<template>
    <div class="page_content" style="padding-top:10px;padding-left:10px;">
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="form" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="业务类型">
                        <label slot="label" :style="$common.labelStyle('业务类型')" v-html="$common.htmlLabel('业务类型')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.orderType"></el-input>
                    </el-form-item>
                    <el-form-item label="业务单号">
                        <label slot="label" :style="$common.labelStyle('业务单号')" v-html="$common.htmlLabel('业务单号')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.businessNum"></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称">
                        <label slot="label" :style="$common.labelStyle('商品名称')" v-html="$common.htmlLabel('商品名称')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.bgmName"></el-input>
                    </el-form-item>
                    <el-form-item label="批号">
                        <label slot="label" :style="$common.labelStyle('批号')" v-html="$common.htmlLabel('批号')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.batchno"></el-input>
                    </el-form-item>
                    <el-form-item label="批次号">
                        <label slot="label" :style="$common.labelStyle('批次号')" v-html="$common.htmlLabel('批次号')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.lotno"></el-input>
                    </el-form-item>
                    <el-form-item label="货主">
                        <label slot="label" :style="$common.labelStyle('货主')" v-html="$common.htmlLabel('货主')"></label>
                        <el-input class="form_codition" size="mini" clearable v-model="form.coName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-table stripe border highlight-current-row size="mini" :height="tableHeight" :key="$store.state.tableNum" :data="tableData" style="width: 100%">
            <el-table-column align="center" prop="bgsId" label="库存ID" width="140">
            </el-table-column>
            <el-table-column align="center" prop="orderType" label="业务类型" width="120">
            </el-table-column>
            <el-table-column align="center" prop="locknum" label="占用数量" width="120">
            </el-table-column>
            <el-table-column align="center" prop="businessNum" label="业务单号" width="140">
            </el-table-column>
            <el-table-column align="center" prop="bgmName" label="通用名称" width="120">
            </el-table-column>
            <el-table-column align="center" prop="bgmCode" label="商品编号" width="140">
            </el-table-column>
            <el-table-column align="center" prop="spec" label="规格" width="120">
            </el-table-column>
            <el-table-column align="center" prop="manufacturer" label="生产厂商" width="160">
            </el-table-column>
            <el-table-column align="center" prop="placeorigin" label="产地" width="120">
            </el-table-column>
            <el-table-column align="center" prop="batchno" label="批号" width="120">
            </el-table-column>
            <el-table-column align="center" prop="prodate" label="生产日期" width="120">
                <template slot-scope="{row}">
                    {{ dealTime(row.prodate) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="expidate" label="有效期" width="120">
                <template slot-scope="{row}">
                    {{ dealTime(row.expidate) }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="lotno" label="批次号" width="140">
            </el-table-column>
            <el-table-column align="center" prop="coName" label="货主名称" width="120">
            </el-table-column>
            <el-table-column align="center" prop="createrName" label="创建人" width="120">
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" width="120">
                <template slot-scope="{row}">
                    {{ dealTime(row.createTime) }}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="form.page" :page-sizes="[20, 50, 100]" :page-size="20" layout="total, sizes, prev, pager, next, jumper" :total="res.total">
        </el-pagination>

    </div>
</template>

<script>
export default {
    name: 'stockOccupyData',
    props: {},
    data() {
        return {
            tableHeight: 0,
            form: {
                batchno: "",
                bgmName: "",
                businessId: "",
                businessNum: "",
                coName: "",
                creater: 0,
                end: 0,
                lotno: "",
                orderType: "",
                ormId: 0,
                page: 0,
                rows: 20,
                start: 0
            },
            tableData: [],
            res: {},
        };
    },
    watch: {},
    computed: {},
    created() {
        this.form = {
            batchno: "",
            bgmName: "",
            businessId: "",
            businessNum: "",
            coName: "",
            creater: 0,
            end: 0,
            lotno: "",
            orderType: "",
            ormId: 0,
            page: 0,
            rows: 20,
            start: 0
        }
        this.queryList()
        this.getButtonList()
    },
    methods: {

        onSearch() {
            this.queryList()
        },
        async queryList() {
            const response = await this.$http.queryStockOccupy(this.form)
            this.res = response.result
            if (response.status == 200) {
                this.tableData = this.res.list
            }
        },
        setDataPageSize(val) {
            this.form.rows = val
            this.queryList()
        },
        setDataPageNumber(val) {
            this.form.page = val
            this.queryList()

        },
        dealTime(time) {
            if (!time) return ""
            return this.$common.getLocalTime(time)
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        getPageInfo() {
            this.queryList()
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.$http.bgStockReleaseAbnormal().then(res => {
                        if (res && res.status == 200) {
                            this.$message({
                                message: res.message,
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                    break
            }
            
        }
    
},

mounted() { },
updated() { this.tableHeight = this.$common.getTableHeight() },
};
</script>